import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Radio,
  ListItemText,
  Typography,
  Grid,
} from "@mui/material";
import PropTypes from "prop-types";

const companyTypes = [
  "Individual",
  "LLC - Limited Liability Corp",
  "LLP - Limited Liability Partnership",
  "Corporation C",
  "Corporation S",
];
/*istanbul ignore next */
export default function CompanyTypeDropdown({ formik, handleFieldMapping }) {
  return (
    <Grid item xs={4} container alignItems="center" spacing={0}>
      <Grid
        item
        xs={5.5}
        container
        alignItems="center"
        spacing={0}
        style={{ marginTop: "12px" }}
      >
        <Typography
          className="agency-name-align-link"
          style={{ marginRight: "8px" }}
        >
          Company Type <span style={{ color: "red" }}>*</span>
        </Typography>
      </Grid>

      <Grid
        item
        xs={6.45}
        container
        alignItems="center"
        spacing={0}
        style={{ marginTop: "8px" }}
      >
        <FormControl fullWidth size="small">
          <InputLabel id="companyType-label">Select Company Type</InputLabel>
          <Select
            sx={{ mb: "-6px", fontSize: "15px" }}
            labelId="companyType-label"
            id="companyType"
            name="companyType"
            value={formik.values?.companyType || ""}
            label="Select Company Type"
            onChange={(e) => handleFieldMapping("companyType", e.target.value)}
            renderValue={(selected) => selected}
          >
            {companyTypes.map((type) => (
              <MenuItem key={type} value={type}>
                <Radio
                  checked={formik.values?.companyType === type}
                  sx={{ marginRight: 1 }}
                />
                <ListItemText primary={type} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <span style={{ color: "red", fontSize: "12px" }}>
        {formik.errors?.companyType}
      </span>
    </Grid>
  );
}

CompanyTypeDropdown.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      companyType: PropTypes.string,
    }),
    errors: PropTypes.shape({
      companyType: PropTypes.string,
    }),
  }).isRequired,
  handleFieldMapping: PropTypes.func.isRequired,
};

CompanyTypeDropdown.defaultProps = {
  formik: {
    values: { companyType: "" },
    errors: {},
  },
};
